(function(angular) {
    window.app.controller('feedbackCtrl', ['$scope', '$http', '$compile', '$mdDialog', function ($scope, $http, $compile, $mdDialog) {
            
        $scope.user = {};
        $scope.license = false;
        $scope.telFormat = {
                     
             
        }
        $scope.showFeedbackAlert = function(){
            if(!$scope.user.name){
                $scope.showAlert('warning','Wprowadź swoje imię');
            }
            if(!$scope.user.email){
                $scope.showAlert('warning','Podaj e-mail');
            }
            if(!$scope.user.text){
                $scope.showAlertMessage('Zadaj pytanie');
            }
            if(!$scope.license){
                $scope.showAlertMessage('Zadaj pytanie');
            }
        }
        $scope.requestSuccess = function(response){
            if(JSON.parse(response.data).sendSuccess){
                $scope.user = {}
                $scope.showAlertMessage('Dziękujemy za wiadomość, nasz zespół wsparcia skontaktuje się z Tobą w określonych w zasadach terminach.');
            }
            else{
                $scope.user = {}
                $scope.showAlertMessage('Liczba wniosków przekroczyła limit dzienny. Napisz do nas jutro.');
            }          
        }
        $scope.requestFail = function(response){
            console.log('error '+response.status)
            $scope.showAlertMessage('Ze względów technicznych Twój wniosek nie został wysłany. Spróbuj ponownie później')
                      
        }

        $scope.sendSupportForm = function(){
            if($scope.user.name && $scope.user.email && $scope.user.text && $scope.license){
                $scope.sendXHR({
                    url: '/rest/forms/feedback-form',
                    data: $scope.user,
                    successFunc: $scope.requestSuccess,
                    errorFunc: $scope.requestFail
                });
            }
            // else{$scope.showFeedbackAlert()} 
        }

        $scope.showAlertMessage = (text) => {
            $mdDialog.show({
                preserveScope: true,
                template:
                `<div id="modal-popup-feedback">
                    <div class="layout" layout-align="end">
                        <span class="modal-close-btn" aria-label="close" ng-click="hideAlertMessage()">X</span>
                    </div>
                    <p class="title text-center">${text}</p>
                </div>`,
                parent: angular.element(document.body),
                scope: $scope,
            });
        }

        $scope.hideAlertMessage = () => {
            $mdDialog.hide();
        }

        $scope.showContact = function(ev){
            $mdDialog.show({
                clickOutsideToClose:true,
                preserveScope: true,
                template:
                `<div class="md-dialog_contact">
                    <p class="bolder font-d-24">Skontaktuj się z nami</p>
                    <form class="md-dialog_contact_input " ng-submit="sendSupportForm()" name="feedbackForm" autocomplete="off" novalidate>
                            <md-input-container>
                                <input type="text" name="name" placeholder="Imię" maxlength="20" data-default-value="" ng-pattern="/^[a-zA-ZŹźŻżÓóŃńŁłĘęĆŚśćĄą\-\s\']*$/" minlength="2" ng-model="user.name" ng-keyup="inputValCtrl.delFailSymbol('name')" required>
                                <div ng-messages="feedbackForm.name.$error">
                                    <div ng-message="required">Wprowadź swoje imię</div>
                                    <div ng-message="pattern">Format pola tylko litery.</div>
                                    <div ng-message="minlength">Wprowadź swoje imię, Nie mniej niż 2 znaki.</div>
                                </div>
                            </md-input-container>
                            <md-input-container>
                                <input placeholder="Numer telefonu" maxlength="12" data-default-value="" minlength="12" ng-pattern="/^[+]{1}[4]{1}[8]{1}[0-9]{9}$/" type="tel" name="tel" ng-model="user.phone" ng-focus="inputValCtrl.tel.setPrefix()" ng-blur="inputValCtrl.tel.clear()">
                                <div ng-messages="feedbackForm.tel.$error">
                                    <div ng-message="pattern">Format pola numer telefonu "+481234567892"</div>
                                    <div ng-message="minlength">Minimum 13 symbole</div>
                                </div>
                            </md-input-container>
                            <md-input-container>
                                <input type="email" name="email" placeholder="Adres e-mail" maxlength="30" minlength="10" data-default-value="" ng-pattern="/^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-z0-9]+\.[a-z]{2,7}$/" ng-model="user.email" required>
                                <div ng-messages="feedbackForm.email.$error">
                                    <div ng-message="required">Podaj e-mail</div>
                                    <div ng-message="pattern">Podaj e-mail</div>
                                    <div ng-message="minlength">Minimum 10 symbole</div>
                                </div>
                            </md-input-container>
                            <md-input-container>
                                <input type="text" class="subject" placeholder="Twoje pytanie" ng-model="user.text" maxlength="500" minlength="10" name="text" rows="1" required md-select-on-focus>
                                <div ng-messages="feedbackForm.text.$error">
                                    <div ng-message="required">Zadaj pytanie</div>
                                    <div ng-message="minlength">Najmniej 10 znaków</div>
                                </div>
                            </md-input-container>
                        <button type="submit" aria-label="send-question" class="feedBack_button">Wysłać</button>
                        <md-input-container class="display-flex checkbox-feedBack">
                                <input type="checkbox" name="license" ng-model="license" required>
                                <p>Zgadzam się z <span style="color: #19A0E5"><a href="/regulamin/">warunkami korzystania</a></span>
                                z raccoongo.com i <span style="color: #19A0E5"><a href="/polityka-prywatnosci/">polityką prywatności</a></span></p>
                            <div ng-messages="feedbackForm.license.$error">
                                    <div ng-message="required">Musi być potwierdzone*</div>
                            </div>
                        </md-input-container>
                    </form>
                </div>`,
                parent: angular.element(document.body),
                scope: $scope,
            });
        }

    }]); 
})(window.angular);


// WEBPACK FOOTER //
// src/js/controllers/forms/feedbackCtrl.js